<template>
  <div class="single-product__price-box-container">
    <div class="single-product__price-box" v-if="oldPrice && oldPriceIsDifferent">
      <span class="single-product__price--promotion q-fw-semibold q-my-2">
        {{ formatPrice(price, currencyCode, removeDecimals) }}
      </span>
      <span class="single-product__price--old">
        <span class="single-product__price--old-text ">
            {{ SmartSearchTranslations.autocomplete.oldPriceText }}:
        </span>
        <span class="single-product__price--old-value q-fw-semibold">
          {{ formatPrice(oldPrice, currencyCode, removeDecimals) }}
        </span>
      </span>

      <div v-if="omnibusPrice && omnibusPriceIsDifferent" class="single-product__omnibus-price-note">
            <span class="single-product__omnibus-price-label">{{
                SmartSearchTranslations.autocomplete.omnibusLowestPrice
              }}:
              <span class="single-product__omnibus-price-wrapper">
                <span class="single-product__omnibus-price">{{
                    formatPrice(omnibusPrice, currencyCode, removeDecimals)
                  }}</span>
              </span>
            </span>
      </div>
    </div>
    <div v-else class="single-product__price-box q-fw-semibold  q-my-2">
          <span class="single-product__price">
            {{ formatPrice(price, currencyCode, removeDecimals) }}
          </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import {defineProps, inject, ref, watchEffect} from 'vue';
import {formatPrice, getRealPrice, parsePrice} from "@/core/utils";
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from '@/core/types'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)

const props = defineProps(['product']);


const {removeDecimals, currency: currencyCode} = SmartSearchConfig.value.appConfiguration

let oldPriceValue = ref(props.product.old_price || props.product.sale_price)
let {price, oldPrice} = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value))
let omnibusPrice = parsePrice(props.product.omnibus_price)
let oldPriceIsDifferent = price !== oldPrice
let omnibusPriceIsDifferent = price !== omnibusPrice
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


watchEffect(() => {
  oldPriceValue = ref(props.product.old_price || props.product.sale_price)
  price = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value)).price
  oldPrice = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value)).oldPrice
  omnibusPrice = parsePrice(props.product.omnibus_price)
  oldPriceIsDifferent = price !== oldPrice
  omnibusPriceIsDifferent = price !== omnibusPrice
});
</script>
<style scoped>
.smartsearch-autocomplete__popup-container .products__single-product .single-product__price--promotion {
  margin: 0 !important;
  margin-top: 0.25em!important;

}
.smartsearch-autocomplete__popup-container .products__single-product .single-product__price--old-text{
  display: none;
}
.single-product__price--promotion {
  color: #d10b10;
  display: block;
}

.single-product__price--old-text,
.single-product__price--old {
  font-size: 0.85em;
  font-weight: 400;
  color: #595959;
}

.single-product__price--old-value {
  text-decoration: line-through;
}

.single-product__price-box-container .single-product__omnibus-price-note {
  width: 100%
}

.single-product__price-box-container .single-product__omnibus-price-label {
  display: block;
  font-size: 10px;
  font-weight: 400;
  color: #595959;
}

</style>